import { render } from "./listProducts.vue?vue&type=template&id=1e2b7524&scoped=true"
import script from "./listProducts.vue?vue&type=script&lang=js"
export * from "./listProducts.vue?vue&type=script&lang=js"

import "./listProducts.vue?vue&type=style&index=0&id=1e2b7524&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2b7524"]])

export default __exports__